module.exports = __webpack_public_path__ + "templates/password-change.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/customer-account/templates/password-change.html
// module id = ofvn
// module chunks = 1